import {create} from "zustand";
import {IPageName, IVMStore} from "../interfaces";
import produce from "immer";
import {deepCopy} from "../services/utils";
interface IVMUseStore {
    data: IVMStore;
    detailModel: string;
    completedForm: boolean;
    validForm: string[];
    editForm: string;
    setData: (val: any, page: IPageName) => void;
    showDetailModel: (src: string) => void;
    setCompletedForm: () => void;
    setValidForm: (validForm: string, type?: "remove" | "add") => void;
    setEditForm: (val: string) => void;
}

const useVMStore = create<IVMUseStore>()((set) => ({
    data: {
        page2: {
            stradresseDesProjektasse: "",
            googleAddressLink: "",
        },
        page3: "",
        page4: "",
        page5: "",
        page6: "",
        page7: "",
        page8: "",
        page9: {
            dach: 0,
            eg: 1,
            ug: 0,
        },
        page10: {
            type: "",
        },
        page12: "",
        page13: {
            files: [],
        },
        page14: "",
        /*page15: {
            vorname: "",
            nachname: "",
            plz: "",
            ort: "",
            email: "",
            telefon: "",
            strasse: "",
            firma: "",
            rechnungsadresse: false,
            r_anschrift: "",
            r_strasse: "",
            r_plz: "",
            r_ort: "",
        },*/
        page15: {
            vorname: "",
            nachname: "",
            email: "",
            telefon: "",
            firma: "",
            rechnungsadresse: false,
            r_anschrift: "",
            r_strasse: "",
            r_plz: "",
            r_ort: "",
        }
    },
    detailModel: "",
    completedForm: false,
    validForm: ["page9", "page13", "page14"],
    editForm: "",

    setData: (val, page) => {
        set(
            produce((state: IVMUseStore) => {
                state.data[page] = val;
            }),
        );
    },
    showDetailModel: (src) => {
        set(() => ({detailModel: src}));
    },
    setCompletedForm: () => {
        set(() => ({completedForm: true}));
    },
    setValidForm: (validForm: string, type = "add") => {
        set((state: IVMUseStore) => {
            if (type === "remove") {
                const idx = state.validForm.indexOf(validForm);
                if (idx !== -1) {
                    const curArr = state.validForm;
                    // curArr.splice(idx, 1);
                    const newArr = curArr.filter((_, index) => index !== idx);
                    return {validForm: [...deepCopy(newArr)]};
                }
            } else {
                if (!state.validForm.includes(validForm)) {
                    return {validForm: [...deepCopy(state.validForm), validForm]};
                }
            }
            return {};
        });
    },
    setEditForm: (val) => {
        set(() => ({editForm: val}));
    },
}));

export default useVMStore;
